import React from 'react'
import Warning from '@mui/icons-material/Warning'
import { Grid } from '@mui/material'

import styles from './ReminderWarning.module.scss'

export interface ReminderWarningProps {
  message: React.ReactNode
}

const ReminderWarning = ({ message }: ReminderWarningProps) => (
  <Grid className={styles['reminder-warning']}>
    <Grid className={styles['warning-icon-wrapper']}>
      <Warning className={styles['warning-icon']} />
    </Grid>
    <span>{message}</span>
  </Grid>
)

export default ReminderWarning
